import { Button, buttonRecipe } from "components/core/basic/Button";
import { Badge, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { GiPathDistance } from "react-icons/gi";
import { trellisPalette } from "components/custom/analytics/palettes";
import { Wrap } from "../../../styled-system/jsx";
import { css } from "../../../styled-system/css";
import { useMemo } from "react";
import { HoverInfo } from "../../components/core/basic/Tooltip";

const ReportTypeCard = ({ query, onSelect, onViewSubscriptions, subscribed, featured, availableSources = [] }) => {
  const { id, display_name, name, description, byline, required_datasources: requiredSources } = query;

  const hasAccessToReport = useMemo(() => {
    return requiredSources?.every((source) => availableSources.includes(source)) ?? true;
  }, [requiredSources, availableSources]);

  const renderFeaturedReportIcon = (reportName) => {
    const iconBackgroundStyles = {
      width: "40px",
      height: "40px",
      backgroundColor: trellisPalette[10],
      color: "#FFF",
      borderRadius: "100%",
      fontSize: "22px",
    };
    switch (reportName) {
      case "Shopper Insights":
        return (
          <div
            style={{ ...iconBackgroundStyles, backgroundColor: trellisPalette[3] }}
            className="d-flex align-items-center justify-content-center me-3"
          >
            <i className="pe-7s-cart" style={{ fontWeight: 600 }} />
          </div>
        );
      case "Path to Purchase":
        return (
          <div style={iconBackgroundStyles} className="d-flex align-items-center justify-content-center me-3">
            <GiPathDistance size={22} style={{ stroke: "#FFF", strokeWidth: "12px" }} />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <Col xs={12} md={6} className="p-5">
      <div className="border h-100" style={{ padding: "16px 18px", borderRadius: "6px" }}>
        <div className="d-flex flex-column gap-2 justify-content-between h-100">
          <div>
            <h4
              className={`my-0 d-flex gap-1 ${featured ? "" : "px-3"} py-0`}
              style={{ fontWeight: 600, fontSize: "18px" }}
            >
              {featured && <div className="my-auto">{renderFeaturedReportIcon(display_name)}</div>}{" "}
              <div>
                {display_name}
                {requiredSources?.length ?
                  <div>
                    <Badge
                      className={`${css({ marginBottom: "10px", borderRadius: "5px", fontSize: "12px" })} badge bg-trellis-purple`}
                      pill
                    >
                      FSI
                    </Badge>
                  </div>
                : null}

                <span
                  style={{ fontWeight: 400, lineHeight: 1.4, fontSize: "13px", marginTop: featured ? "-5px" : "-3px" }}
                  className={`fst-italic  mb-3 d-block`}
                >
                  {byline}
                </span>
              </div>
            </h4>

            <p className="fs-5 p-3" style={{ minHeight: "50px" }}>
              {description}
            </p>
          </div>
          <Wrap justifyContent={"space-evenly"} fontSize="medium" width="100%" paddingX="medium" gap="medium">
            {subscribed || featured ?
              ["SHOPPER_INSIGHTS"].includes(name) ?
                <Link
                  to={featured ? query.href : `/user/amc/dashboard/reports/${id}`}
                  className={buttonRecipe({ variant: "secondary" })}
                >
                  View Report
                </Link>
              : <>
                  <Button variant="secondary" onPress={onSelect} isDisabled={!hasAccessToReport}>
                    Create New Subscription
                  </Button>
                  <Button
                    variant="link"
                    onPress={() => {
                      onViewSubscriptions();
                    }}
                  >
                    View Subscriptions
                  </Button>
                </>

            : <Button variant="secondary" onPress={onSelect} isDisabled={!hasAccessToReport}>
                Subscribe
                {!hasAccessToReport ?
                  <HoverInfo>
                    This query requires a subscription to AMCs Flexible Shopper Insights to access the data needed to
                    build this report
                  </HoverInfo>
                : null}
              </Button>
            }
          </Wrap>
        </div>
      </div>
    </Col>
  );
};

export default ReportTypeCard;
